<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    d="M13.4188 3.12946C14.0806 2.6567 15 3.12982 15 3.94319V20.0568C15 20.8702 14.0806 21.3433 13.4188 20.8705L8 17H5C3.89543 17 3 16.1046 3 15V9C3 7.89543 3.89543 7 5 7H8L13.4188 3.12946Z"
    [attr.fill]="color"
  />
  <path
    d="M17.9938 16.9053C19.2347 15.6422 20 13.9105 20 12C20 10.0815 19.2282 8.34321 17.9781 7.07878"
    [attr.stroke]="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
